import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { APIContainer, LogTypes, sawinFunc } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as CustomerRequestMdl from '../models/CustomerRequestBucket';
import { CustomerRequestListLoadInfo } from './CustomerRequestList';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.


export interface CustomerRequestProcessing { type: 'CUSTOMERREQUEST_PROCESSING', processing: boolean }
export interface CustomerRequestError { type: 'CUSTOMERREQUEST_ERROR', error: string }
export interface CustomerRequestSuccess { type: 'CUSTOMERREQUEST_SUCCESS' }
export interface CustomerRequestReset { type: 'CUSTOMERREQUEST_RESET' }

export type KnownAction = CustomerRequestProcessing | CustomerRequestError | CustomerRequestSuccess | CustomerRequestReset | CustomerRequestListLoadInfo;

export const actionCreators = {
    request: (pCustomerRequest: CustomerRequestMdl.CustomerRequestBucketModel): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;

        console.log(`SerOrProp:${pCustomerRequest.serviceOrProposal}`);
        //pCustomerRequest.serviceOrProposal = "S";
        pCustomerRequest.serviceMasterNum = sessionState.SelectedSM.id;
        pCustomerRequest.companyCode = sessionState.SelectedAR.companyCode;

        dispatch({ type: 'CUSTOMERREQUEST_PROCESSING', processing: true });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/CustomerRequest',
            {
                method: 'POST',
                body: JSON.stringify(pCustomerRequest),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {

                if (container.success) {
                    const data: CustomerRequestMdl.CustomerRequestBucketModel = container.data;
                    //Do something with response             
                    dispatch({ type: 'CUSTOMERREQUEST_SUCCESS' });                        
                } else {
                    dispatch({
                        type: 'CUSTOMERREQUEST_ERROR', error: container.errorInfo.message
                    });
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'CUSTOMERREQUEST_ERROR', error: err.message
                });
                sawinFunc.log({ message: err.message, logType: LogTypes.Error, clientMessage: '' });
            });
    },
    resetState: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: "CUSTOMERREQUEST_RESET" });
    }
};

export const reducer: Reducer<CustomerRequestMdl.CustomerRequestBucketModel> = (state: CustomerRequestMdl.CustomerRequestBucketModel | undefined, incomingAction: Action): CustomerRequestMdl.CustomerRequestBucketModel => {

    if (state === undefined) {
        return { ...CustomerRequestMdl.initialState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'CUSTOMERREQUEST_PROCESSING':
            return { ...state, processing: (action as CustomerRequestProcessing).processing }      
        case 'CUSTOMERREQUEST_ERROR':            
            return { ...state, processing: false, error: (action as CustomerRequestError).error }        
        case 'CUSTOMERREQUEST_SUCCESS':
            return { ...state, processing: false, error: '', success: 'Y' }     
        case 'CUSTOMERREQUEST_RESET':
            return { ...state, ...CustomerRequestMdl.initialState  }     
        default:
            return state;
    }
}; 